// =====================================================================
//  Controller de création d'une stratégie OTP.
//  Route proxy : GET /otp-strategy/create/{fkProjet} (persiste un défaut).
// =====================================================================

import {ResponseApi} from "../../Model/ResponseApi.js";
import {JsonFetchJson} from "../../Helper/FetchHelper.js";
import {IOtpStrategyModel} from "../../Model/Otp/OtpStrategyModel.js";
import {OnOtpStrategyAdd} from "../../Delegates/OtpStrategyDelegate.js";

export class OtpCreate {
    public static Create = async (fkProjet: string): Promise<IOtpStrategyModel | undefined> => {
        const response = await JsonFetchJson.Get<ResponseApi<IOtpStrategyModel>>(
            `/otp-strategy/create/${fkProjet}`,
        );
        if (response.Data)
            OnOtpStrategyAdd.Fire(response.Data);
        return response.Data;
    };
}
